import {
  Box_default
} from "./chunk-GDQZHQO7.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-M54I523Y.js";

// packages/ui-lib/src/theme/RootBox.tsx
import React2, {
  forwardRef,
  useContext,
  useEffect,
  useMemo,
  useState,
  createContext
} from "react";
import cn from "classnames";

// packages/ui-lib/src/theme/theme.css.ts
var coarsePointerTheme = "theme__153rx7n1";
var darkTheme = "theme__153rx7n3";
var finePointerTheme = "theme__153rx7n0";
var lightTheme = "theme__153rx7n2";

// packages/ui-lib/src/theme/RootBox.css.ts
var root = "RootBox__11ja1dh0";

// packages/ui-lib/src/theme/RootBox.tsx
var ColorThemeContext = createContext("system");
var PointerThemeContext = createContext("system");
var ThemeProvider = ({
  color,
  pointer,
  children
}) => /* @__PURE__ */ React2.createElement(ColorThemeContext.Provider, {
  value: color
}, /* @__PURE__ */ React2.createElement(PointerThemeContext.Provider, {
  value: pointer
}, children));
var useColorTheme = () => {
  const colorFromContext = useContext(ColorThemeContext);
  const [systemColor, setSystemColor] = useState(() => window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
  useEffect(() => {
    const listener = (e) => {
      setSystemColor(e.matches ? "dark" : "light");
    };
    const matcher = window.matchMedia("(prefers-color-scheme: dark)");
    matcher.addEventListener("change", listener);
    return () => matcher.removeEventListener("change", listener);
  }, []);
  return colorFromContext === "system" ? systemColor : colorFromContext;
};
var usePointerTheme = () => {
  const pointerFromContext = useContext(PointerThemeContext);
  const systemTheme = useMemo(() => window.matchMedia("(pointer: coarse)").matches ? "coarse" : "fine", []);
  return pointerFromContext === "system" ? systemTheme : pointerFromContext;
};
var RootBox = forwardRef((_a, forwardedRef) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  const colorTheme = useColorTheme();
  const pointerTheme = usePointerTheme();
  const classNames = cn(root, className, {
    [lightTheme]: colorTheme === "light",
    [darkTheme]: colorTheme === "dark",
    [finePointerTheme]: pointerTheme === "fine",
    [coarsePointerTheme]: pointerTheme === "coarse"
  });
  return /* @__PURE__ */ React2.createElement(Box_default, __spreadProps(__spreadValues({}, props), {
    className: classNames,
    ref: forwardedRef
  }));
});
RootBox.displayName = "RootBox";

export {
  ThemeProvider,
  useColorTheme,
  RootBox
};
//# sourceMappingURL=chunk-EGZMSSTV.js.map
